import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
const { TextArea: AntdTextArea } = Input

const TextArea = ({
  className = '',
  onChange = () => {},
  label,
  name,
  placeholder = '',
  isRequired = true,
  value = '',
  maxLength = null,
  hint = '',
  rows = 4,
  hideLabel = false,
  wrapperClass = '',
  errorHelp = false,
  errorMsg = '',
}) => {
  return (
    <Form.Item
      name={name}
      label={label ? label : ''}
      className={`${wrapperClass} ${hideLabel ? 'hide-label' : ''}`}
      style={{ marginBottom: 0 }}
      rules={
        isRequired
          ? [
              {
                required: true,
                message:
                  errorHelp === false
                    ? ''
                    : errorMsg.length > 0
                      ? errorMsg
                      : `Please enter "${label}"`,
              },
            ]
          : undefined
      }
      {...(errorHelp === false ? { help: '' } : {})}
      validateStatus={hint ? 'error' : undefined}
    >
      <AntdTextArea
        autoComplete="off"
        className={className}
        placeholder={placeholder || label}
        value={value}
        rows={rows}
        maxLength={maxLength}
        onChange={(e) => {
          onChange(e.target.value)
        }}
      />
    </Form.Item>
  )
}

TextArea.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.any,
  maxLength: PropTypes.number,
  hint: PropTypes.bool,
  rows: PropTypes.number,
  hideLabel: PropTypes.bool,
  wrapperClass: PropTypes.string,
  errorHelp: PropTypes.bool,
  errorMsg: PropTypes.string,
}

export default TextArea
